import { defineStore } from 'pinia';
import { useAuthStore } from '@/stores/auth';

export const useBranchesStore = defineStore('branches', {
    state: () => {
        return {
            allBranches: [],
            requested: false
        };
    },
    actions: {
        async loadBranches(refresh: boolean = false) {
            if (!this.requested || refresh) {
                this.allBranches = (await useAuthStore().request(false).get('api/branches')).data.data;
                this.requested = true;
            }

            return this.branches;
        },
        getBranch(branchId: number) {
            return this.allBranches.find(({ id }) => id === branchId);
        },
        activeBranches() {
            return this.branches.filter(branch => branch.assets_count > 0);
        }
    },
    getters: {
        branches: state => {
            const authStore = useAuthStore();

            return state.allBranches.filter(b => !authStore.allowed_branches || authStore.allowed_branches.includes(b.id));
        },
        currentBranch: state => {
            const authStore = useAuthStore();

            return state.allBranches.find(b => b.id === authStore.branch_id);
        },
        branchInvoiceSettings: state => {
            const authStore = useAuthStore();

            const branch = state.allBranches.find(b => b.id === authStore.branch_id);

            return branch.invoice_settings || {
                textColor: 'a65f00',
                orderNumberColor: 'db2777',
                fontFamily: '',
                fontFamilyImport: '',
                paperSize: 'A5',
                paperOrientation: 'landscape',
                companyName: '__company_name__',
                ownerName: 'خليل محمد احمد',
                header1: 'لتصنيع المجوهرات',
                header2: '(جملة ومفرق)',
                showOrderNumber: true,
                showOrderType: true,
                companyLogo: '__company_logo__',
                mainBranchLabel: 'المقر الرئيسي:',
                mainBranchAddress: '__main_branch_address__',
                companyMobileLabel: 'Mobile: ',
                companyMobile: '__company_mobile__',
                companyTelephoneLabel: 'Tel: ',
                companyTelephone: '',
                branchLabel: 'الفرع: ',
                branchAddress: '__branch_address__',
                branchMobileLabel: 'Tel: ',
                branchMobile: '__branch_mobile__',
                factoryLabel: 'المصنع: ',
                factoryAddress: '',
                LicensedLabel: 'مشغل مرخص',
                LicensedNumber: ''
            };
        }
    }
});
